import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon, PackageIcon } from 'lucide-react';
type BonusCardProps = {
  number: number;
  title: string;
  value: string;
  imageSrc: string;
  imageAlt: string;
  copy: string;
  bullets: {
    title: string;
    description: string;
  }[];
  deliverables: string[];
};
export function BonusCard({
  number,
  title,
  value,
  imageSrc,
  imageAlt,
  copy,
  bullets,
  deliverables
}: BonusCardProps) {
  return <section className="py-16 md:py-20 px-5 md:px-8 relative" data-id="element-40">
      <div className="max-w-5xl mx-auto" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="relative bg-gradient-to-br from-[#0B1224] to-[#070B16] border border-[#F6C65B]/30 rounded-3xl p-6 md:p-10 shadow-[0_0_40px_rgba(246,198,91,0.1)] overflow-hidden" data-id="element-42">
          {/* Tag */}
          <div className="flex justify-center mb-6" data-id="element-43">
            <div className="inline-flex items-center gap-2 bg-[#F6C65B] text-[#070B16] rounded-full px-4 py-1.5 shadow-lg" data-id="element-44">
              <GiftIcon className="w-4 h-4" data-id="element-45" />
              <span className="text-xs md:text-sm font-bold tracking-wider uppercase" data-id="element-46">
                Regalo Gratis #{number} · Solo Hoy
              </span>
            </div>
          </div>

          <h3 className="text-2xl md:text-4xl font-bold text-center text-white leading-tight mb-3" data-id="element-47">
            {title}
          </h3>

          <div className="flex justify-center items-center gap-3 mb-8" data-id="element-48">
            <span className="text-gray-500 line-through text-base md:text-lg" data-id="element-49">
              Valor: {value}
            </span>
            <span className="bg-green-500/20 text-green-400 border border-green-500/30 font-bold text-xs md:text-sm px-3 py-1 rounded-full" data-id="element-50">
              Hoy GRATIS
            </span>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center" data-id="element-51">
            {/* Image */}
            <div className="relative" data-id="element-52">
              <div className="absolute inset-0 bg-[#F6C65B] rounded-2xl blur-2xl opacity-10" data-id="element-53"></div>
              <img src={imageSrc} alt={imageAlt} width="1024" height="1024" loading="lazy" decoding="async" className="relative w-full max-w-sm mx-auto rounded-2xl shadow-2xl" data-id="element-54" />
            </div>

            {/* Content */}
            <div data-id="element-55">
              <p className="text-gray-200 text-base md:text-lg leading-relaxed mb-6" data-id="element-56">
                {copy}
              </p>

              <div className="space-y-4 mb-6" data-id="element-57">
                {bullets.map((b, i) => <div key={i} className="flex items-start gap-3" data-id="element-58">
                    <CheckIcon className="w-5 h-5 text-[#F6C65B] mt-1 flex-shrink-0" data-id="element-59" />
                    <div data-id="element-60">
                      <p className="text-white font-semibold" data-id="element-61">{b.title}</p>
                      <p className="text-gray-400 text-sm" data-id="element-62">{b.description}</p>
                    </div>
                  </div>)}
              </div>

              <div className="border-t border-[#F6C65B]/20 pt-5" data-id="element-63">
                <div className="flex items-center gap-2 mb-3" data-id="element-64">
                  <PackageIcon className="w-4 h-4 text-[#F6C65B]" data-id="element-65" />
                  <span className="text-[#F6C65B] text-xs font-bold tracking-wider uppercase" data-id="element-66">
                    Qué incluye
                  </span>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-67">
                  {deliverables.map((d, i) => <span key={i} className="bg-[#F6C65B]/10 border border-[#F6C65B]/30 text-gray-200 text-xs md:text-sm px-3 py-1.5 rounded-full" data-id="element-68">
                      {d}
                    </span>)}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}